import type { Household } from '@frontend/api-types';

export const getOtherHouseholdMembers = (currentClientId: MaybeNil<string>, household: MaybeNil<Household>) =>
  household?.members?.filter(({ id: hhMemberId }) => hhMemberId !== currentClientId) ?? [];
